import React from 'react';

const IcArrowSquareRight = () => {
    return (
        <svg width='36' height='37' viewBox='0 0 36 37' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12.5C0 5.87258 5.37258 0.5 12 0.5H24C30.6274 0.5 36 5.87258 36 12.5V24.5C36 31.1274 30.6274 36.5 24 36.5H12C5.37258 36.5 0 31.1274 0 24.5V12.5Z' fill='#F0F6FF' />
            <path
                d='M12.3335 18.5C12.3337 18.132 12.6324 17.834 13.0005 17.834L21.4165 17.834L18.8569 15.2168C18.5996 14.9536 18.6035 14.5309 18.8667 14.2734C19.13 14.016 19.5527 14.0209 19.8101 14.2842L23.4761 18.0342C23.7294 18.2933 23.7294 18.7077 23.4761 18.9668L19.8101 22.7168C19.5526 22.98 19.1299 22.9839 18.8667 22.7266C18.6039 22.4691 18.5997 22.0473 18.8569 21.7842L21.4155 19.167L13.0005 19.167C12.6323 19.167 12.3335 18.8682 12.3335 18.5Z'
                fill='#264C97'
            />
        </svg>
    );
};

export default IcArrowSquareRight;
